import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    api
      .post("/auth/session", { session_id: sessionId })
      .then((r) => {
        const user = r.data?.user;
        if (!user?.is_admin) {
          setError("This account is not authorised for the admin area.");
          return;
        }
        navigate("/admin", { replace: true, state: { user } });
      })
      .catch((e) => {
        setError(e?.response?.data?.detail || "Authentication failed.");
      });
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-ivory">
      <div className="text-center max-w-md">
        <p className="overline">Authenticating</p>
        <h1
          className="mt-3 text-3xl text-ink"
          style={{ fontFamily: '"Cormorant Garamond", serif', fontWeight: 500 }}
        >
          {error ? "Could not sign you in" : "Signing you in…"}
        </h1>
        {error && (
          <p className="mt-4 body-prose text-ink/70 text-sm">{error}</p>
        )}
        {error && (
          <a
            href="/admin/login"
            className="mt-6 inline-flex px-6 py-3 text-[12px] uppercase tracking-[0.22em] border border-ink/30"
          >
            Try again
          </a>
        )}
      </div>
    </div>
  );
}
